// /src/core/logout.ts
import { isLocalHost } from "./http";
import { clearBffTokenCache } from "../modules/bffTokenCache";
import { clearProfileSummaryCache } from "../modules/profileSummary";

export function logoutToIndex() {
    const post = `${window.location.origin}/`;
    const loginHint = sessionStorage.getItem("login_hint"); // may be null
    const extra = loginHint ? `&logout_hint=${encodeURIComponent(loginHint)}` : "";

    const logoutUrl = `/.auth/logout?post_logout_redirect_uri=${encodeURIComponent(post)}${extra}`;
    clearBffTokenCache(); // we don't redirect user in local but we clear cache
    clearProfileSummaryCache();
    if (isLocalHost(window.location.hostname)) return;
    window.location.replace(logoutUrl);
}